"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var Icon_1 = require("../Icon");
var utilityGreen = honeycomb_1.Styles.Colors.Aliases.success;
var Switch = function (props) {
    var id = props.id, isOn = props.isOn, isSaving = props.isSaving, label = props.label, forwardRef = props.forwardRef, onClick = props.onClick, screenReaderForOff = props.screenReaderForOff, screenReaderForOn = props.screenReaderForOn, screenReaderForSaving = props.screenReaderForSaving;
    var _a = React.useState(isOn), on = _a[0], setOn = _a[1];
    var _b = React.useState(isSaving), saving = _b[0], setIsSaving = _b[1];
    var onClickSwitch = function () {
        if (onClick) {
            onClick();
        }
        setOn(!on);
    };
    var classNames = (0, classnames_1.default)('switch', { 'switch--spinner': isSaving });
    var classNamesStatus = (0, classnames_1.default)('switch-indicator', { 'switch-spinning': saving }, { 'switch-spinning--left': saving && on }, { 'switch-spinning--right': saving && !on }, { 'switch-on': !saving && on }, { 'switch-off': !saving && !on });
    var IconComponent = null;
    if (!saving && on) {
        IconComponent = (React.createElement(Icon_1.Icon, { screenreader: screenReaderForOn, svgArgs: {
                fill1: utilityGreen,
            }, symbol: "Tick24", type: "svginline" }));
    }
    else if (!saving && !on) {
        IconComponent = (React.createElement(Icon_1.Icon, { screenreader: screenReaderForOff, symbol: "controlClose24", type: "svginline" }));
    }
    React.useEffect(function () {
        setIsSaving(isSaving);
    }, [isSaving]);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { htmlFor: id, className: "switch-label" }, label),
        React.createElement("button", { role: "switch", onClick: onClickSwitch, disabled: isSaving, "aria-checked": on, id: id, className: classNames, ref: forwardRef },
            React.createElement("span", { className: classNamesStatus },
                IconComponent,
                saving &&
                    React.createElement("span", { className: "sr-only" },
                        " ",
                        screenReaderForSaving,
                        " ")))));
};
exports.Switch = Switch;
exports.Switch.defaultProps = {
    isOn: false,
    isSaving: false,
    screenReaderForOff: 'Off',
    screenReaderForOn: 'On',
    screenReaderForSaving: 'Saving',
};
exports.Switch.propTypes = {
    forwardRef: PropTypes.any,
    id: PropTypes.string.isRequired,
    isOn: PropTypes.bool,
    isSaving: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    screenReaderForOff: PropTypes.string,
    screenReaderForOn: PropTypes.string,
    screenReaderForSaving: PropTypes.string,
};
